import axios from 'axios';

Shopify.functions.removeItem = async function removeItem(lineItemKey, additionalData) {
  try {
    const data = {
      id: lineItemKey,
      quantity: 0,
      ...additionalData
    }

    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    }

    const response = await axios.post(theme.routes.cart_change_url, data, config);
    const cart = response.data;
    return cart;
  } catch (error) {
    console.error("Removing item error: ", error);
  }
};